/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { UnansweredCommentsTabContainer_story$ref } from "./UnansweredCommentsTabContainer_story.graphql";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DOWNVOTE_DESC" | "REPLIES_DESC" | "UPVOTE_DESC" | "%future added value";
export type UnansweredCommentsTabContainerPaginationQueryVariables = {
    readonly count: number;
    readonly cursor?: unknown | null;
    readonly orderBy: COMMENT_SORT;
    readonly storyID?: string | null;
};
export type UnansweredCommentsTabContainerPaginationQueryResponse = {
    readonly story: {
        readonly " $fragmentRefs": UnansweredCommentsTabContainer_story$ref;
    } | null;
};
export type UnansweredCommentsTabContainerPaginationQuery = {
    readonly response: UnansweredCommentsTabContainerPaginationQueryResponse;
    readonly variables: UnansweredCommentsTabContainerPaginationQueryVariables;
};



/*
query UnansweredCommentsTabContainerPaginationQuery(
  $count: Int!
  $cursor: Cursor
  $orderBy: COMMENT_SORT!
  $storyID: ID
) {
  story(id: $storyID) {
    ...UnansweredCommentsTabContainer_story_32czeo
    id
  }
}

fragment UnansweredCommentsTabContainer_story_32czeo on Story {
  id
  isClosed
  settings {
    live {
      enabled
    }
  }
  comments(first: $count, after: $cursor, orderBy: $orderBy, tag: UNANSWERED) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...ReplyListContainer1_comment
        ...IgnoredTombstoneOrHideContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...CommentContainer_story
  ...ReplyListContainer1_story
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  ...ReplyCommentFormContainer_comment
  ...EditCommentFormContainer_comment
  ...ReactionButtonContainer_comment
  ...ReportButtonContainer_comment
  ...CaretContainer_comment
  ...RejectedTombstoneContainer_comment
  ...AuthorBadgesContainer_comment
  ...UserTagsContainer_comment
  ...UsernameWithPopoverContainer_comment
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 3, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  ...MessageBoxContainer_story
  settings {
    messageBox {
      enabled
    }
    mode
  }
}

fragment CommentContainer_story on Story {
  url
  isClosed
  settings {
    mode
  }
  ...CaretContainer_story
  ...ReplyCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...EditCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment ReplyListContainer1_story on Story {
  isClosed
  settings {
    live {
      enabled
    }
  }
  ...ReplyListContainer2_story
  ...CommentContainer_story
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentMutation_story on Story {
  settings {
    moderation
  }
}

fragment ReplyListContainer2_story on Story {
  isClosed
  settings {
    live {
      enabled
    }
  }
  ...ReplyListContainer3_story
  ...CommentContainer_story
}

fragment ReplyListContainer3_story on Story {
  isClosed
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
  ...LocalReplyListContainer_story
}

fragment LocalReplyListContainer_story on Story {
  ...CommentContainer_story
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 3, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 3, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...LocalReplyListContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  author {
    username
    id
  }
  editing {
    editableUntil
  }
}

fragment ReactionButtonContainer_comment on Comment {
  id
  revision {
    id
  }
  viewerActionPresence {
    reaction
    upvote
    downvote
  }
  actionCounts {
    reaction {
      total
    }
    upvote {
      total
    }
    downvote {
      total
    }
  }
}

fragment ReportButtonContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment AuthorBadgesContainer_comment on Comment {
  author {
    badges
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "count",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "cursor",
            "type": "Cursor",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "orderBy",
            "type": "COMMENT_SORT!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "storyID",
            "type": "ID",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v2 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enabled",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any),
        (v2 /*: any*/),
        ({
            "kind": "Literal",
            "name": "tag",
            "value": "UNANSWERED"
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v6 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "badges",
                "args": null,
                "storageKey": null
            },
            (v7 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "ignoreable",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "parent",
        "storageKey": null,
        "args": null,
        "concreteType": "Comment",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v6 /*: any*/),
                    (v3 /*: any*/)
                ]
            },
            (v3 /*: any*/)
        ]
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "body",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "editing",
        "storageKey": null,
        "args": null,
        "concreteType": "EditInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "edited",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "editableUntil",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v13 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "tags",
        "storageKey": null,
        "args": null,
        "concreteType": "Tag",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "deleted",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "revision",
        "storageKey": null,
        "args": null,
        "concreteType": "CommentRevision",
        "plural": false,
        "selections": [
            (v3 /*: any*/)
        ]
    } as any), v16 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "viewerActionPresence",
        "storageKey": null,
        "args": null,
        "concreteType": "ActionPresence",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "reaction",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "upvote",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "downvote",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "dontAgree",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "flag",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v17 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
        } as any)
    ], v18 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "actionCounts",
        "storageKey": null,
        "args": null,
        "concreteType": "ActionCounts",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "reaction",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v17 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "upvote",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v17 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "downvote",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v17 /*: any*/)
            }
        ]
    } as any), v19 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 3
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": "CREATED_AT_ASC"
        } as any)
    ], v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pending",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastViewerAction",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enteredLive",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v26 = ({
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewNewEdges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommentEdge",
                "plural": true,
                "selections": [
                    (v24 /*: any*/)
                ]
            }
        ]
    } as any), v27 = ({
        "kind": "LinkedHandle",
        "alias": null,
        "name": "replies",
        "args": (v19 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "filters": [
            "orderBy"
        ]
    } as any), v28 = ({
        "kind": "ClientExtension",
        "selections": [
            (v21 /*: any*/),
            (v22 /*: any*/),
            (v23 /*: any*/)
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_story",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isClosed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "settings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "live",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "messageBox",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "content",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "icon",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mode",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "moderation",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comments",
                            "storageKey": null,
                            "args": (v5 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v8 /*: any*/),
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v7 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v18 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "replies",
                                                    "storageKey": "replies(first:3,orderBy:\"CREATED_AT_ASC\")",
                                                    "args": (v19 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "edges",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "node",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "replies",
                                                                            "storageKey": "replies(first:3,orderBy:\"CREATED_AT_ASC\")",
                                                                            "args": (v19 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "edges",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "node",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v3 /*: any*/),
                                                                                                (v8 /*: any*/),
                                                                                                (v9 /*: any*/),
                                                                                                (v10 /*: any*/),
                                                                                                (v7 /*: any*/),
                                                                                                (v11 /*: any*/),
                                                                                                (v12 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "replies",
                                                                                                    "storageKey": "replies(first:3,orderBy:\"CREATED_AT_ASC\")",
                                                                                                    "args": (v19 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "alias": null,
                                                                                                            "name": "edges",
                                                                                                            "storageKey": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "alias": null,
                                                                                                                    "name": "node",
                                                                                                                    "storageKey": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v3 /*: any*/),
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "alias": null,
                                                                                                                            "name": "replyCount",
                                                                                                                            "args": null,
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v8 /*: any*/),
                                                                                                                        (v9 /*: any*/),
                                                                                                                        (v10 /*: any*/),
                                                                                                                        (v7 /*: any*/),
                                                                                                                        (v11 /*: any*/),
                                                                                                                        (v12 /*: any*/),
                                                                                                                        (v13 /*: any*/),
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v15 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                (v21 /*: any*/),
                                                                                                                                (v22 /*: any*/),
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "alias": null,
                                                                                                                                    "name": "localReplies",
                                                                                                                                    "storageKey": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "Comment",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        (v3 /*: any*/),
                                                                                                                                        (v8 /*: any*/),
                                                                                                                                        (v9 /*: any*/),
                                                                                                                                        (v10 /*: any*/),
                                                                                                                                        (v7 /*: any*/),
                                                                                                                                        (v11 /*: any*/),
                                                                                                                                        (v12 /*: any*/),
                                                                                                                                        (v13 /*: any*/),
                                                                                                                                        (v21 /*: any*/),
                                                                                                                                        (v22 /*: any*/),
                                                                                                                                        (v14 /*: any*/),
                                                                                                                                        (v15 /*: any*/),
                                                                                                                                        (v16 /*: any*/),
                                                                                                                                        (v18 /*: any*/)
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                (v23 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                (v24 /*: any*/)
                                                                                                            ]
                                                                                                        },
                                                                                                        (v25 /*: any*/),
                                                                                                        (v26 /*: any*/)
                                                                                                    ]
                                                                                                },
                                                                                                (v27 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v28 /*: any*/)
                                                                                            ]
                                                                                        },
                                                                                        (v24 /*: any*/)
                                                                                    ]
                                                                                },
                                                                                (v25 /*: any*/),
                                                                                (v26 /*: any*/)
                                                                            ]
                                                                        },
                                                                        (v27 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v28 /*: any*/)
                                                                    ]
                                                                },
                                                                (v24 /*: any*/)
                                                            ]
                                                        },
                                                        (v25 /*: any*/),
                                                        (v26 /*: any*/)
                                                    ]
                                                },
                                                (v27 /*: any*/),
                                                (v20 /*: any*/),
                                                (v28 /*: any*/)
                                            ]
                                        },
                                        (v24 /*: any*/)
                                    ]
                                },
                                (v25 /*: any*/),
                                (v26 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "comments",
                            "args": (v5 /*: any*/),
                            "handle": "connection",
                            "key": "UnansweredStream_comments",
                            "filters": [
                                "orderBy",
                                "tag"
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "id": "b4087e91b765cced51ce71fa6a980089",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '897b8f65230b26d53862eb0c752c5f77';
export default node;
